import { SET_TV_SETTINGS } from '../types/tvSettings'

const initState = {
  tvSettings: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_TV_SETTINGS:
      return { ...state, tvSettings: action.payload.tvSettings, lastModified: new Date().getTime() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tvSettings.js